import { Component, OnInit, Input, HostListener } from '@angular/core';
import { NavController, ActionSheetController, AlertController, Events, IonTabs, MenuController, ModalController, Platform, PopoverController } from '@ionic/angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { MessageclientService } from '../../../service/messageclient.service';
import { BaseCase } from '../../basecase';
import { BaseModal } from '../../../model/base';
import { HandleWebParameterContextBeforeDBRequest } from '../../../bizlogic/servicesbll';
import { WebParameterContext } from '../../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../service/common.service';
import { WxjssdkService } from "src/service/wxjssdk.service";
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import {CodelessReturnslistPage} from '../../codeless-returnslist/codeless-returnslist.page'
declare var app;
@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements OnInit {
  num: number = 0;
  PageName: string;
  returnGoodsObj: {};
  BoxCountlenall: any;
  constructor(
    private barcode: BarcodeScanner,
    private platform: Platform,
    private msg: MessageclientService,
    private baseService: BaseCase,
    private activateRoute: ActivatedRoute,
    public base: BaseModal,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public menuCtrl: MenuController,
    public actionSheetCtrl: ActionSheetController,
    public popoverCtrl: PopoverController,
    public http: HttpCustomerService,
    public com: CommonService,
    private alertController: AlertController,
    public wx: WxjssdkService
  ) { }

  @Input()
  eleName: any;
  ngOnInit() {
    this.PageName = this.activateRoute.snapshot.paramMap.get('ConfigName');
    this.baseService.arrayData = [];
  }
  CamerData() {
    const that = this;
    console.log("二维码");

    const PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
    const id = that.activateRoute.snapshot.paramMap.get('id');
    if (PageName == "ActivityCenterDetail") {//活动详情页面
      if (id) {
        that.com.setHistoryUrl();
        let url = app.WEBSITE + "/CustomView/MemberSign?ActivityID=" + id.split("&")[0] + "&PGID=" + that.com.GetAccount.Id;
        // let url = "http://a2_pgmstext.brandmax.com.cn:9530/CustomView/MemberSign?ActivityID="+id+"&PGID="+that.com.GetAccount.Id;
        that.com.goQrCode(url);
      }
      return;
    }
    if (PageName == "ScanCodeSales") {
      // that.msg.Confirm("请选择方式", "手动输入", "扫码识别").then(data => {
      //   if (data) {
      //     // that.com.setHistoryUrl();
      //     //console.log(data,"扫码");
      //     that.scanQrcode(PageName);
      //   } else {
      //     //console.log(data,"手动");
      //     this.presentAlertInput();
      //   }
      // })

      that.presentAlertCheck(PageName);
    }
    // if(PageName){

    //   if(PageName=="ScanCodeSales"){
    //     let _obj = {};
    //     if(that.num==0){
    //       _obj["a_Code"]="BE9421902960017";
    //     }else if(that.num==1){
    //       _obj["a_Code"]="BE9421902960154";
    //     }else if(that.num==2){
    //       _obj["a_Code"]="BE9421902960024";
    //     }else if(that.num==3){
    //       _obj["a_Code"]="BE9335390000547";
    //       that.num=-1;
    //     }
    //     that.LoadDataBind(_obj);
    //   }
    //   that.num +=1;
    //   return;
    // }

    // that.com.setHistoryUrl();
  }
  /**
   * 扫码盘库
   */
  EventCamerData() {
    const that = this;
    // that.msg.Alert("扫码活动");
    console.log(that.PageName, "返回扫码消息");

    that.presentAlertCheck(that.PageName);
  }
  /**
   * 扫码退货
   */
  EventReturnGoods() {
    const that = this;
    that.presentAlertCheck(that.PageName);
  }
  /**
   * 
   * @param 无码退货
   */
  // EventReturnsaluse(){
  //   let that= this;
  //   that.codelessModal()
  // }
  //  // 无码产品选择
  //  async codelessModal(){
  //   let that =this;
  //   const modal = await that.modalCtrl.create({
  //     component: CodelessReturnslistPage,
  //     componentProps: {
  //       "ids": "1",
  //       "checkItem":"2",
  //       "typeItem": 1
  //     }
  //   });
  //   await modal.present();
  //   const { data } = await modal.onWillDismiss();
  //   if(data.result.ResponseMessage.Success){
  //     let tempList:Array<any>=new Array<any>();
  //          tempList=data.result.Status;
  //          /**
  //           * 产品处理
  //           */
  //          data.result.Status.ProductData.forEach(it => {
  //           //  debugger;
  //            let pushObj = {};
  //            pushObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
  //            pushObj["TankBarcode"] = it["TankBarcode"] || "";
  //            pushObj["BoxBarcode"] = it["BoxBarcode"] || "";
  //            pushObj["PurchaseID"] = it["PurchaseID"] || "";
  //            pushObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
  //            pushObj["BoxCount"] = it["Num"] || 0;
  //            pushObj["Num"] = it["Num"] || 0;
  //            if(!that.baseService.ListData.find(pro=>pro.PurchaseID==it.PurchaseID)){
  //             if( that.baseService.ListData.find(pro=>pro.ProductInfoCode==it.ProductInfoCode)){
  //               that.baseService.ListData.find(pro=>pro.ProductInfoCode==it.ProductInfoCode).Num+=it["Num"]||0;
  //              }else{
  //               that.baseService.ListData.push(pushObj);
  //              }
  //            }
  //            if(!that.baseService.arrayData.find(pro=>pro.PurchaseID==it.PurchaseID)){
  //             that.baseService.arrayData.push(pushObj);//
  //            }
  //          });
  //         //  赠品处理
  //         data.result.Status.GiftData.forEach(gift => {
  //           if(that.baseService.giftArrayList.find(pt=> pt.a_FK_TBGift_ID== gift.a_FK_TBGift_ID)){
  //             that.baseService.giftArrayList.find(pt=> pt.a_FK_TBGift_ID== gift.a_FK_TBGift_ID).Num += gift.a_Num||0;
  //           }else{
  //             gift.Num=gift.a_Num||0;
  //             that.baseService.giftArrayList.push(gift);
  //             console.log( that.baseService.giftArrayList,"赠品数据赠品数据")
  //           }
           
  //         });
            
  //  }
  //  console.log( that.baseService.arrayData);
  //   console.log(data,"onWillDismiss");
  // }
  LoadDataBind(obj: any) {
    // debugger;
    const that = this;
    const PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (that.PageName == "ReturnGoods") {
      //消费者退货
      body.ConfigName = "ProductReturn";
    }
    else if (that.PageName == "ProductStorage") {
      //产品入库ww
      body.ConfigName = "ProductStorage";
    }
    else {
      body.ConfigName = "ScanCodeXML";// "TBProductInformationXML";//产品名称
    }
    body.RequestBody = JSON.stringify(obj);
   
    if (that.PageName == "ReturnGoods" && that.baseService.arrayData.length > 0) {//退货判断，如果当前缓存中有退货数据则先判断扫的码是否重复
    //消费者退货
      let _code: any = obj.Code || "";
      if (_code.indexOf("/") != -1) {
        let lastindex: number = _code.lastIndexOf("\/") || 0;
        _code = _code.substring(lastindex + 1, _code.length);
      }
      let isbox: boolean = false;
      that.baseService.arrayData.forEach(box => {
        if (box.BoxBarcode.toLowerCase() == _code.toLowerCase()) {
          isbox = true;
        } else {
          let _tankBar: any = box.TankBarcode.split(",") || [];
          _tankBar.forEach(bar => {
            if (bar.toLowerCase() == _code.toLowerCase()) {
              isbox = true;
            }
          })
        }
      });
      if (isbox) {
        that.msg.Alert("已录入，请勿重复录入");
        return;
      }
    }

    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log('begin bug');
      // debugger;
      if (data.ResponseMessage.Success) {
        if (that.PageName != "ReturnGoods") {
          let isproduct: boolean = false;

          if (that.base.IntegralCodeDetailList.length > 0) {
            // data.Status.IntegralCodeDetailList.forEach(prod=>{
            //   that.base.IntegralCodeDetailList.forEach(pc=>{
            //     if(prod.IntegralCode==pc.IntegralCode){
            //       isproduct=true;
            //     }
            //   });
            // });
            that.base.IntegralCodeDetailList.forEach(pc => {
              if (pc == obj.Code) {
                isproduct = true;
              }
            });
            if (isproduct) {
              that.msg.Alert("已录入，请勿重复录入");
              return;
            } else {
              that.base.IntegralCodeDetailList.push(obj.Code);
            }
          } else {
            that.base.IntegralCodeDetailList.push(obj.Code);
          }
          let _data = {};
          _data["id"] = data.Status.productId;
          _data["name"] = data.Status.productname;
          _data["num"] = data.Status.Count;
          // _data["Code"]=obj.Code;
          _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
          let isproductnum: boolean = false;
          that.base.GridArrayData.forEach(item => {
            if (item.id == data.Status.productId) {
              data.Status.IntegralCodeDetailList.forEach(items => {
                item.IntegralCodeDetailList.push(items);
              });
              let coun1: number = item.num;
              let count2: number = data.Status.Count;
              let count3: number = coun1 + count2;
              item.num = count3;
              isproductnum = true;
            }
          });
          if (!isproductnum) {
            that.base.GridArrayData.push(_data);
          }
          let sumNum: number = data.Status.Count;
          that.base.GridListCount += sumNum;
        } else if(that.PageName == "ReturnGoods"){
            if (data.Status.Datas.ProductData.length > 0) {
              console.log(data.Status);
              data.Status.Datas.ProductData.forEach(it => {
                let TankBarcodelen = it.TankBarcode.split(",").length;
                let BoxCountlen = data.Status.BoxCount;
                if (TankBarcodelen > BoxCountlen && TankBarcodelen > 1) {
                  that.BoxCountlenall = data.Status.BoxCount;
                } else if (TankBarcodelen <= BoxCountlen && TankBarcodelen > 1) {
                  that.BoxCountlenall = TankBarcodelen;
                }
                else {
                  that.BoxCountlenall = 1;
                }

              })

              console.log(data.Status.Datas);
              // console.log(data.Status.TankBarcode);
              //   console.log(data.Status.TankBarcode.split(","));
              //   console.log(data.Status.TankBarcode.split(",").length);
              // that.baseService.ListData.forEach(it=>{
              //   console.log(it.TankBarcode);
              //   console.log(it.TankBarcode.split(","));
              //   console.log(it.TankBarcode.split(",").length);

              // })
              let isExists = false;
              // data.Status.Datas.forEach(it => {//判断箱码
              //   if(that.baseService.arrayData.find(x=>x.BoxBarcode==it["BoxBarcode"]))
              //   {
              //    isExists=true;
              //    return false;
              //   }
              // });

              // if(!isExists){

              data.Status.Datas.ProductData.forEach(_t => {//判断罐码
                let _newTp: Array<any> = _t.TankBarcode.split(",") || [];//返回结果
                _newTp.forEach(_m => {
                  that.baseService.arrayData.forEach(s => {
                    let _tp: Array<any> = s.TankBarcode.split(",") || [];
                    if (_tp == _m) {
                      isExists = true;
                    }
                  });
                });

              });
              // }
              if (isExists) {
                that.msg.Alert("已录入，请勿重复录入");
                return false;
              }

              data.Status.Datas.ProductData.forEach(it => {
                console.log(it, "+++++++++++++++++++++++++++++")
                // that.baseService.arrayData =[];
                let pushObj = {};
                pushObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
                pushObj["TankBarcode"] = it["TankBarcode"] || "";
                pushObj["BoxBarcode"] = it["BoxBarcode"] || "";
                pushObj["PurchaseID"] = it["PurchaseID"] || "";
                pushObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
                pushObj["BoxCount"] = that.BoxCountlenall || "";

                that.baseService.arrayData.push(pushObj);//完全的添加数据
                // that.baseService.ListData.push(pushObj);

                //修饰过得数据
                if (that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])) {
                  data.Status.Datas.ProductData.forEach(it => {
                    let TankBarcodelen = it.TankBarcode.split(",").length;
                    let BoxCountlen = data.Status.BoxCount;

                    if (TankBarcodelen > BoxCountlen && TankBarcodelen > 1) {
                      console.log("显示的数据")
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + BoxCountlen;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = BoxCountlen;


                    } else if (TankBarcodelen <= BoxCountlen && TankBarcodelen > 1) {
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + TankBarcodelen;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = TankBarcodelen;
                    }
                    else {
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + 1;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = 1;
                    }


                    console.log("里边罐码的数量", it.TankBarcode.split(",").length);

                  })
                } else {
                  //  
                  let newListObj = {};
                  newListObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
                  newListObj["TankBarcode"] = it["TankBarcode"] || "";
                  newListObj["PurchaseID"] = it["PurchaseID"] || "";
                  newListObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
                  newListObj["Num"] = it["Num"] || "";
                  newListObj["BoxCount"] = it["BoxCount"] || "";
                  



                  // 箱规的数量
                  console.log("箱规", data.Status.BoxCount);
                  data.Status.Datas.ProductData.forEach(it => {
                    let TankBarcodelen = it.TankBarcode.split(",").length;

                    if (TankBarcodelen > data.Status.BoxCount && TankBarcodelen > 1) {
                      console.log("显示的数据zzzzzzzzzzzzzzzz")
                      newListObj["Num"] = data.Status.BoxCount;
                      newListObj["BoxCount"] = data.Status.BoxCount;
                    } else if (TankBarcodelen <= data.Status.BoxCount && TankBarcodelen > 1) {
                      console.log("显示的数据z,mmmmmmm")
                      newListObj["Num"] = TankBarcodelen;
                      newListObj["BoxCount"] = TankBarcodelen;
                    } else {
                      newListObj["Num"] = 1;
                    }

                    // if(data.Status.BoxCount !== TankBarcodelen &&  TankBarcodelen >1 && data.Status.BoxCount > TankBarcodelen){
                    //   console.log("显示的数据")
                    //   newListObj["Num"]=data.Status.BoxCount;
                    //   newListObj["BoxCount"]=data.Status.BoxCount;
                    // }else if(TankBarcodelen < data.Status.BoxCount   &&  TankBarcodelen >1){
                    //   newListObj["Num"]=TankBarcodelen;
                    //   newListObj["BoxCount"]=TankBarcodelen;
                    // }
                    // else{
                    //   newListObj["Num"]=1;
                    // }

                    console.log("里边罐码的数量", it.TankBarcode.split(",").length);
                  })
                  console.log('tag', newListObj);
                  that.baseService.ListData.push(newListObj);
                  //  that.baseService.arrayData.push(newListObj);

                }

                // that.baseService.ListData=that.baseService.arrayData ;
                console.log("listdata", that.baseService.ListData);
                console.log("yuanshi", that.baseService.arrayData);
              });
              /**
               * 赠品处理
               */
              // data.Status.Datas.GiftData.forEach(gift => {
              //   if(that.baseService.giftArrayList.find(pt=> pt.a_FK_TBGift_ID== gift.a_FK_TBGift_ID)){
              //     that.baseService.giftArrayList.find(pt=> pt.a_FK_TBGift_ID== gift.a_FK_TBGift_ID).Num += gift.a_Num||0;
              //   }else{
              //     gift.Num=gift.a_Num||0;
              //     that.baseService.giftArrayList.push(gift);
              //     console.log( that.baseService.giftArrayList,"赠品数据赠品数据")
              //   }
               
              // });
              data.Status.Datas.GiftData.forEach(gift => {
                gift.Num=gift.a_Num||0;
                if(!that.baseService.giftArrayList.find(ts=>ts.a_Order_ID==gift.a_Order_ID && ts.a_FK_TBGift_ID==gift.a_FK_TBGift_ID)){
                  that.baseService.giftArrayList.push(gift);
                }
                  console.log( that.baseService.giftArrayList,"赠品数据赠品数据")

              });

            }
        }
        else
         {
          if (data.Status.Datas.length > 0) {
            if (data.Status.Datas.length > 0) {
              console.log(data.Status);
              data.Status.Datas.forEach(it => {
                let TankBarcodelen = it.TankBarcode.split(",").length;
                let BoxCountlen = data.Status.BoxCount;
                if (TankBarcodelen > BoxCountlen && TankBarcodelen > 1) {
                  that.BoxCountlenall = data.Status.BoxCount;
                } else if (TankBarcodelen <= BoxCountlen && TankBarcodelen > 1) {
                  that.BoxCountlenall = TankBarcodelen;
                }
                else {
                  that.BoxCountlenall = 1;
                }

              })

              console.log(data.Status.Datas);
              // console.log(data.Status.TankBarcode);
              //   console.log(data.Status.TankBarcode.split(","));
              //   console.log(data.Status.TankBarcode.split(",").length);
              // that.baseService.ListData.forEach(it=>{
              //   console.log(it.TankBarcode);
              //   console.log(it.TankBarcode.split(","));
              //   console.log(it.TankBarcode.split(",").length);

              // })
              let isExists = false;
              // data.Status.Datas.forEach(it => {//判断箱码
              //   if(that.baseService.arrayData.find(x=>x.BoxBarcode==it["BoxBarcode"]))
              //   {
              //    isExists=true;
              //    return false;
              //   }
              // });

              // if(!isExists){

              data.Status.Datas.forEach(_t => {//判断罐码
                let _newTp: Array<any> = _t.TankBarcode.split(",") || [];//返回结果
                _newTp.forEach(_m => {
                  that.baseService.arrayData.forEach(s => {
                    let _tp: Array<any> = s.TankBarcode.split(",") || [];
                    if (_tp == _m) {
                      isExists = true;
                    }
                  });
                });

              });
              // }
              if (isExists) {
                that.msg.Alert("已录入，请勿重复录入");
                return false;
              }

              data.Status.Datas.forEach(it => {
                console.log(it, "+++++++++++++++++++++++++++++")
                // that.baseService.arrayData =[];
                let pushObj = {};
                pushObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
                pushObj["TankBarcode"] = it["TankBarcode"] || "";
                pushObj["BoxBarcode"] = it["BoxBarcode"] || "";
                pushObj["PurchaseID"] = it["PurchaseID"] || "";
                pushObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
                pushObj["BoxCount"] = that.BoxCountlenall || "";

                that.baseService.arrayData.push(pushObj);//完全的添加数据
                // that.baseService.ListData.push(pushObj);

                //修饰过得数据
                if (that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])) {
                  data.Status.Datas.forEach(it => {
                    let TankBarcodelen = it.TankBarcode.split(",").length;
                    let BoxCountlen = data.Status.BoxCount;

                    if (TankBarcodelen > BoxCountlen && TankBarcodelen > 1) {
                      console.log("显示的数据")
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + BoxCountlen;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = BoxCountlen;


                    } else if (TankBarcodelen <= BoxCountlen && TankBarcodelen > 1) {
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + TankBarcodelen;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = TankBarcodelen;
                    }
                    else {
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + 1;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = 1;
                    }


                    console.log("里边罐码的数量", it.TankBarcode.split(",").length);

                  })
                } else {
                  //  
                  let newListObj = {};
                  newListObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
                  newListObj["TankBarcode"] = it["TankBarcode"] || "";
                  newListObj["PurchaseID"] = it["PurchaseID"] || "";
                  newListObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
                  newListObj["Num"] = it["Num"] || "";
                  newListObj["BoxCount"] = it["BoxCount"] || "";



                  // 箱规的数量
                  console.log("箱规", data.Status.BoxCount);
                  data.Status.Datas.forEach(it => {
                    let TankBarcodelen = it.TankBarcode.split(",").length;

                    if (TankBarcodelen > data.Status.BoxCount && TankBarcodelen > 1) {
                      console.log("显示的数据zzzzzzzzzzzzzzzz")
                      newListObj["Num"] = data.Status.BoxCount;
                      newListObj["BoxCount"] = data.Status.BoxCount;
                    } else if (TankBarcodelen <= data.Status.BoxCount && TankBarcodelen > 1) {
                      console.log("显示的数据z,mmmmmmm")
                      newListObj["Num"] = TankBarcodelen;
                      newListObj["BoxCount"] = TankBarcodelen;
                    } else {
                      newListObj["Num"] = 1;
                    }

                    // if(data.Status.BoxCount !== TankBarcodelen &&  TankBarcodelen >1 && data.Status.BoxCount > TankBarcodelen){
                    //   console.log("显示的数据")
                    //   newListObj["Num"]=data.Status.BoxCount;
                    //   newListObj["BoxCount"]=data.Status.BoxCount;
                    // }else if(TankBarcodelen < data.Status.BoxCount   &&  TankBarcodelen >1){
                    //   newListObj["Num"]=TankBarcodelen;
                    //   newListObj["BoxCount"]=TankBarcodelen;
                    // }
                    // else{
                    //   newListObj["Num"]=1;
                    // }

                    console.log("里边罐码的数量", it.TankBarcode.split(",").length);
                  })
                  console.log('tag', newListObj);
                  that.baseService.ListData.push(newListObj);
                  //  that.baseService.arrayData.push(newListObj);

                }

                // that.baseService.ListData=that.baseService.arrayData ;
                console.log("listdata", that.baseService.ListData)
                console.log("yuanshi", that.baseService.arrayData)
              });
            }
            //    let code=obj["Code"];
            //    that.baseService.arrayData.forEach(item=>{
            //  if(that.baseService.ListData.find(x=>x.ProductInfoCode==code))
            //  {
            //   that.baseService.ListData.find(x=>x.ProductInfoCode==code)["Num"]=that.baseService.ListData.find(x=>x.ProductInfoCode==code)["Num"]+1;
            //  }else{
            //   //  

            //   let newListObj={};
            //   newListObj["ProductInfoCode"]=item["ProductInfoCode"]||"";
            //   newListObj["PurchaseID"]     =item["PurchaseID"]||"";
            //   newListObj["ProductName"]    =item["ProductName"]||"";
            //   newListObj["Num"]    =1;
            //   that.baseService.ListData.push(newListObj);

            //  }

            //  

          }
        }
      }
      else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    })
  }

  /**
   * 扫码
   * @param PageName 
   */
  scanQrcode(PageName) {
    const that = this;

    if (that.platform.is('cordova')) {
      // that.com.setHistoryUrl();
      that.barcode.scan().then((scan) => {
        let sancanArray: Array<any> = new Array<any>();
        sancanArray = that.com.GetStorageKey("backurl") || [];
        sancanArray.splice(sancanArray.length - 1, 1);
        localStorage.setItem("backurl", JSON.stringify(sancanArray));
        if (PageName) {
          if (PageName == "ScanCodeSales") {
            let _obj = {};
            if (scan.text) {
              _obj["Code"] = scan.text;
              that.LoadDataBind(_obj);
            }
          } else if (PageName == "ProductInventory") {//产品盘库
            let _obj = {};
            if (scan.text) {
              _obj["Code"] = scan.text;
              that.LoadDataBindInfo(_obj);
            }
          } else if (PageName == "ReturnGoods") {
            let _obj = {};
            if (scan.text) {
              _obj["Code"] = scan.text;
              that.LoadDataBind(_obj);
            }
          }
          else if (PageName == "ProductStorage") {
            let _obj = {};
            if (scan.text) {
              _obj["Code"] = scan.text;
              that.LoadProductStorageInfo(_obj);
            }
          }
          
        } else {
          let webparaContext: WebParameterContext = new WebParameterContext();
          webparaContext.Client.PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
          webparaContext.SpecialParameter = "scanner";
          webparaContext.ConfigName = "scanner";
          let obj = {};
          obj["scanner"] = scan.text;
          obj["data"] = that.baseService.arrayData;
          webparaContext.RequestBody = obj;
          const webBody = HandleWebParameterContextBeforeDBRequest(webparaContext);
          if (!webBody.ResponseMessage.Success) {
            that.msg.Show(webBody.ResponseMessage.ErrorMessage);
          } else {
            that.baseService.arrayData = webBody.RequestBody.data;
            that.baseService.order = webBody.RequestBody.orderdata;
          }
        }
      }).catch(error => {
        that.msg.Show(error);
      });
    } else {
      that.wx.GetWxScanQRCode(1).then(result => {
        console.log(result, "返回扫码消息");
        let _obj = {};
        if (result.Status) {
          _obj["Code"] = result.Status;
          if (PageName) {
            if (PageName == "ProductInventory") {
              that.LoadDataBindInfo(_obj);
            } else if (PageName == "ReturnGoods") {
              that.LoadDataBind(_obj);
            }
            else if (PageName == "ProductStorage") {
              //产品入库
              that.LoadProductStorageInfo(_obj);
            }
          } else {
            that.LoadDataBind(_obj);
          }
        }
      });
      //  console.log(that.baseService.arrayData);
      //  let webparaContext: WebParameterContext = new WebParameterContext();
      //  webparaContext.Client.PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
      //  webparaContext.SpecialParameter = "scanner";
      //  webparaContext.ConfigName = "scanner";
      //  let obj = {};
      //      obj["scanner"]="";
      //      obj["data"]=that.baseService.arrayData;
      //  webparaContext.RequestBody = obj;
      //   const webBody = HandleWebParameterContextBeforeDBRequest(webparaContext);
      //   if(!webBody.ResponseMessage.Success){
      //           that.msg.Show(webBody.ResponseMessage.ErrorMessage);
      //   }else{
      //     that.baseService.arrayData =  webBody.RequestBody.data;
      //     that.baseService.order = webBody.RequestBody.orderdata;
      //   }
    }
  }
/**
 * 扫码产品入库
 * @param PageName 
 */
  async presentAlertCheckProduct(PageName) {
    const that = this;
    const alert = await this.alertController.create({
      header: '系统提示',
      message: "请选择方式",
      mode: "ios",
      cssClass: "more-btn",
      buttons: [
        {
          text: "扫码识别",
          cssClass: 'btn-okay btn-width',
          handler: (Okay = "1") => {
            that.wx.GetWxScanQRCode(1).then(result => {
              console.log(result, "返回扫码消息");
              let _obj = {};
              if (result.Status)
               {
                _obj["Code"] = result.Status;
                that.LoadProductStorageInfo(_obj);
              }
            });
          }
        },
        {
          text: "手动输入",
          cssClass: 'btn-okay btn-width',
          handler: (Okay1 = "2") => {
            that.presentAlertInputProduct();
          }
        },
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel btn-width',
          handler: (cancel) => {
            console.log(cancel, "cancel");
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertCheck(PageName) {
    const that = this;
    const alert = await this.alertController.create({
      header: '系统提示',
      message: "请选择方式",
      mode: "ios",
      cssClass: "more-btn",
      buttons: [
        {
          text: "扫码识别",
          cssClass: 'btn-okay btn-width',
          handler: (Okay = "1") => {
            // console.log(Okay,"ok");
            that.scanQrcode(PageName);
          }
        },
        {
          text: "手动输入",
          cssClass: 'btn-okay btn-width',
          handler: (Okay1 = "2") => {
            // console.log(Okay1,"ok1");
            that.presentAlertInput();
          }
        },
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel btn-width',
          handler: (cancel) => {
            console.log(cancel, "cancel");
          }
        }
      ]
    });

    await alert.present();
  }
/**
 * 产品入库
 */
  async presentAlertInputProduct() {
    const that = this;
    const alert = await this.alertController.create({
      header: '请输入产品罐码/箱码',
      mode: "ios",
      inputs: [
        {
          name: 'a_Code',
          type: 'text',
          label: '请输入产品罐码/箱码',
          value: '',
          min: 6
        }
      ],
      buttons: [
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        },
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            //console.log(Okay,"ok");
            if (Okay && Okay["a_Code"]) {
              let _obj = {};
              _obj["Code"] = Okay["a_Code"];
              that.LoadProductStorageInfo(_obj);
          }
        }
        },

      ]
    });

    await alert.present();
  }
  async presentAlertInput() {
    const that = this;
    const alert = await this.alertController.create({
      header: '请输入产品罐码/箱码',
      mode: "ios",
      inputs: [
        {
          name: 'a_Code',
          type: 'text',
          label: '请输入产品罐码/箱码',
          value: '',
          min: 6
        }
      ],
      buttons: [
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        },
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            //console.log(Okay,"ok");
            if (Okay && Okay["a_Code"]) {
              let _obj = {};
              _obj["Code"] = Okay["a_Code"];
              if (that.PageName) {
                if (that.PageName == "ProductInventory") {
                  that.LoadDataBindInfo(_obj);
                  return;
                } else if (that.PageName == "ProductStorage") {
                  //产品入库
                  that.LoadProductStorageInfo(_obj);
                  return;
                }
              }
              that.LoadDataBind(_obj);
              // that.LoadDataBind_new(_obj);
            } else {
              that.msg.Alert("编码不能为空！");
            }

          }
        },

      ]
    });

    await alert.present();
  }
  /**
   * 产品盘库
   * @param obj 
   */
  LoadDataBindInfo(obj: any) {
    const that = this;
    const PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.ConfigName = "TBInventoryCodeBankXML";//ScanCodeXML "TBProductInformationXML";//产品名称
    body.RequestBody = JSON.stringify(obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log("返回结果");
      if (data.ResponseMessage.Success) {
        console.log("确定对不对");
        console.log(data.Status);
        console.log(data.Status.ResultCode);
        // if(data.Status.ResultCode === 3){
        console.log(data.Status.ResultMSG);
        if (data.Status["productId"]) {
          let _id: any = data.Status["productId"];
          let _temparray: Array<any> = new Array<any>();
          let _prod: any = that.baseService.arrayData.find(item => item.id.value == _id);//获取选中的产品 
          let _stockLength = 0;//添加的库存数量
          let _IntegralCodeDetailList = data.Status["IntegralCodeDetailList"] || [];//当前产品罐码列表
          if (data.Status["Count"]) {
            _stockLength = data.Status["Count"] || 0;
          }
          // if(data.Status["IntegralCodeDetailList"])
          // {
          //   _stockLength=data.Status["IntegralCodeDetailList"].length||0;
          // }
          if (_prod) {
            //添加重复验证逻辑
            if (_prod["IntegralCodeDetailList"]) {
              let prodIsEnter = false;
              _prod["IntegralCodeDetailList"].forEach(integralCode => {//已录入产品罐码
                _IntegralCodeDetailList.forEach(currentProdCode => {//当前产品罐码
                  if (currentProdCode["LogisticsCode"] == integralCode["LogisticsCode"]) {
                    prodIsEnter = true;
                  }
                })
              })
              if (prodIsEnter) {
                that.msg.Alert("已录入，请勿重复录入");
                return;
              }

            }
          }
          //#region 20200312 zora 修改产品盘库添加罐码不一致处理
          if (data.Status.ResultCode === 3) {
            console.log("zmmmm显示的真实数据问题")
            console.log(_IntegralCodeDetailList);
            console.log(_IntegralCodeDetailList.length);
            that.msg.Confirm(`当前产品的扫描数量（${_IntegralCodeDetailList.length}听/罐）与实际箱规数量（${data.Status.boxCount}听/罐）不一致，是否按照实际箱规数量进行盘库?`, "取消", "确定", "", false).then(res => {
              if (res) {
                if (_prod) {
                  if (_prod["IntegralCodeDetailList"]) {
                    _IntegralCodeDetailList.forEach(currentProdCode => {//当前产品罐码
                      let currentProdCodeIsEnter = false;
                      _prod["IntegralCodeDetailList"].forEach(integralCode => {//已录入产品罐码
                        if (currentProdCode["LogisticsCode"] == integralCode["LogisticsCode"]) {
                          currentProdCodeIsEnter = true;
                        }
                      });
                      if (!currentProdCodeIsEnter) {
                        _prod["IntegralCodeDetailList"].push(currentProdCode);
                      }
                    });
                  } else {
                    _prod["IntegralCodeDetailList"] = _IntegralCodeDetailList;
                  }
                  //添加重复验证逻辑
                  _prod.stock.value += _stockLength;
                  _prod["BoxCount"]=data.Status["boxCount"];
                  _prod["checked"] = true;
                  _temparray.push(_prod);
                }
                if (_temparray.length > 0) {
                  that.baseService.arrayData.forEach(items => {
                    if (items.id.value != _id) {
                      _temparray.push(items);
                    }
                  });
                  that.baseService.arrayData = _temparray;
                } else {
                  that.baseService.arrayData.forEach(items => {
                    if (items.id.value == _id) {
                      items.stock.value += _stockLength;
                      items["BoxCount"]=data.Status["boxCount"];
                      items["checked"] = true;
                    }
                  });
                }
                that.scanQrcode(PageName);
              }

            });
          } else {
            if (_prod) {
              if (_prod["IntegralCodeDetailList"]) {
                _IntegralCodeDetailList.forEach(currentProdCode => {//当前产品罐码
                  let currentProdCodeIsEnter = false;
                  _prod["IntegralCodeDetailList"].forEach(integralCode => {//已录入产品罐码
                    if (currentProdCode["LogisticsCode"] == integralCode["LogisticsCode"]) {
                      currentProdCodeIsEnter = true;
                    }
                  });
                  if (!currentProdCodeIsEnter) {
                    _prod["IntegralCodeDetailList"].push(currentProdCode);
                  }
                });
              } else {
                _prod["IntegralCodeDetailList"] = _IntegralCodeDetailList;
              }
              //添加重复验证逻辑
              _prod.stock.value += _stockLength;
              _prod["checked"] = true;
              _prod["BoxCount"]=data.Status["boxCount"];
              _temparray.push(_prod);
            }
            if (_temparray.length > 0) {
              that.baseService.arrayData.forEach(items => {
                if (items.id.value != _id) {
                  _temparray.push(items);
                }
              });
              that.baseService.arrayData = _temparray;
            } else {
              that.baseService.arrayData.forEach(items => {
                if (items.id.value == _id) {
                  items.stock.value += _stockLength;
                  items["BoxCount"]=data.Status["boxCount"];
                  items["checked"] = true;
                }
              });
            }
            that.scanQrcode(PageName);
          }
          //#endregion
        }

      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    })
  }


  ///扫码 产品入库
  EventProductStorage() {
    const that = this;
    that.presentAlertCheckProduct(that.PageName);
  }

  /**
 * ///扫码 产品入库  (手动输入)
 * @param obj 
 */
LoadProductStorageInfo(obj: any) {
  const that = this;
  const PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "element";
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  body.ConfigName = "IsPurchase";//;//产品名称
  body.RequestBody = JSON.stringify(obj);
  that.http.post(app.DEFAULTURL, body).then(data => {
    console.log("返回结果");
    if (data.ResponseMessage.Success) {
      console.log("确定对不对");
      console.log(data.Status);
      console.log(data.Status.ResultCode);
      // if(data.Status.ResultCode === 3){
      console.log(data.Status.ResultMSG);
      if (data.Status["productId"]) {
        let _id: any = data.Status["productId"];
        let _temparray: Array<any> = new Array<any>();
        let _prod: any = that.baseService.arrayData.find(item => item.FK_TBProductInformation_ID== _id);//获取选中的产品 
        let _stockLength = 0;//添加的库存数量
        let _IntegralCodeDetailList = data.Status["IntegralCodeDetailList"] || [];//当前产品罐码列表
        if (data.Status["Count"]) {
          _stockLength = data.Status["Count"] || 0;
        }
        // if(data.Status["IntegralCodeDetailList"])
        // {
        //   _stockLength=data.Status["IntegralCodeDetailList"].length||0;
        // }
        if (_prod) {
          //添加重复验证逻辑
          if (_prod["IntegralCodeDetailList"]) {
            let prodIsEnter = false;
            _prod["IntegralCodeDetailList"].forEach(integralCode => {//已录入产品罐码
              _IntegralCodeDetailList.forEach(currentProdCode => {//当前产品罐码
                if (currentProdCode["LogisticsCode"] == integralCode["LogisticsCode"]) {
                  prodIsEnter = true;
                }
              })
            })
            if (prodIsEnter) {
              that.msg.Alert("已录入，请勿重复录入");
              return;
            }

          }
        }
        //#region 20200312 zora 修改产品盘库添加罐码不一致处理
        if (data.Status.ResultCode === 3) {
          console.log("zmmmm显示的真实数据问题")
          console.log(_IntegralCodeDetailList);
          console.log(_IntegralCodeDetailList.length);
          that.msg.Confirm(`当前产品的扫描数量（${_IntegralCodeDetailList.length}听/罐）与实际箱规数量（${data.Status.boxCount}听/罐）不一致，是否按照实际箱规数量进行盘库?`, "取消", "确定", "", false).then(res => {
            if (res) {
              if (_prod) {
                if (_prod["IntegralCodeDetailList"]) {
                  _IntegralCodeDetailList.forEach(currentProdCode => {//当前产品罐码
                    let currentProdCodeIsEnter = false;
                    _prod["IntegralCodeDetailList"].forEach(integralCode => {//已录入产品罐码
                      if (currentProdCode["LogisticsCode"] == integralCode["LogisticsCode"]) {
                        currentProdCodeIsEnter = true;
                      }
                    });
                    if (!currentProdCodeIsEnter) {
                      _prod["IntegralCodeDetailList"].push(currentProdCode);
                    }
                  });
                } else {
                  _prod["IntegralCodeDetailList"] = _IntegralCodeDetailList;
                }
                //添加重复验证逻辑
                _prod.a_count += _stockLength;
                _prod["checked"] = true;
                _temparray.push(_prod);
              }
              if (_temparray.length > 0) {
                that.baseService.arrayData.forEach(items => {
                  if (items.FK_TBProductInformation_ID != _id) {
                    _temparray.push(items);
                  }
                });
                that.baseService.arrayData = _temparray;
              } else {
                that.baseService.arrayData.forEach(items => {
                  if (items.FK_TBProductInformation_ID == _id) {
                    items.a_count += _stockLength;
                    items["checked"] = true;
                  }
                });
              }
              that.scanQrcode(PageName);
            }

          });
        } else {
          if (_prod) {
            if (_prod["IntegralCodeDetailList"]) {
              _IntegralCodeDetailList.forEach(currentProdCode => {//当前产品罐码
                let currentProdCodeIsEnter = false;
                _prod["IntegralCodeDetailList"].forEach(integralCode => {//已录入产品罐码
                  if (currentProdCode["LogisticsCode"] == integralCode["LogisticsCode"]) {
                    currentProdCodeIsEnter = true;
                  }
                });
                if (!currentProdCodeIsEnter) {
                  _prod["IntegralCodeDetailList"].push(currentProdCode);
                }
              });
            } else {
              _prod["IntegralCodeDetailList"] = _IntegralCodeDetailList;
            }
            //添加重复验证逻辑
            _prod.a_count += _stockLength;
            _prod["checked"] = true;
            _temparray.push(_prod);
          }
          if (_temparray.length > 0) {
            that.baseService.arrayData.forEach(items => {
              if (items.FK_TBProductInformation_ID != _id) {
                _temparray.push(items);
              }
            });
            that.baseService.arrayData = _temparray;
          } else {
            that.baseService.arrayData.forEach(items => {
              if (items.FK_TBProductInformation_ID == _id) {
                items.a_count += _stockLength;
                items["checked"] = true;
              }
            });
          }
          that.scanQrcode(PageName);
        }
        //#endregion
      }

    } else {
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }
  }).catch(error => {
    console.log(error);
    that.msg.Alert(error.ResponseMessage.ErrorMessage);
  })
}


  //扫码 入库（产品入库ww）
  LoadDataBind_ProductStorage(obj: any) {
    const that = this;
    const PageName = that.activateRoute.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (that.PageName == "ReturnGoods") {
      //消费者退货
      body.ConfigName = "ProductReturn";
    }
    else if (that.PageName == "ProductStorage") {
      //产品入库ww
      body.ConfigName = "ProductStorage";
    }
    else {
      body.ConfigName = "ScanCodeXML";// "TBProductInformationXML";//产品名称
    }
    body.RequestBody = JSON.stringify(obj);
    if (that.PageName == "ReturnGoods" && that.baseService.arrayData.length > 0) {//退货判断，如果当前缓存中有退货数据则先判断扫的码是否重复
    //消费者退货
      let _code: any = obj.Code || "";
      if (_code.indexOf("/") != -1) {
        let lastindex: number = _code.lastIndexOf("\/") || 0;
        _code = _code.substring(lastindex + 1, _code.length);
      }
      let isbox: boolean = false;
      that.baseService.arrayData.forEach(box => {
        if (box.BoxBarcode.toLowerCase() == _code.toLowerCase()) {
          isbox = true;
        } else {
          let _tankBar: any = box.TankBarcode.split(",") || [];
          _tankBar.forEach(bar => {
            if (bar.toLowerCase() == _code.toLowerCase()) {
              isbox = true;
            }
          })
        }
      });
      if (isbox) {
        that.msg.Alert("已录入，请勿重复录入");
        return;
      }
    }

    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log('begin bug')
      if (data.ResponseMessage.Success) {
        if (that.PageName != "ReturnGoods") {
          let isproduct: boolean = false;

          if (that.base.IntegralCodeDetailList.length > 0) {
            // data.Status.IntegralCodeDetailList.forEach(prod=>{
            //   that.base.IntegralCodeDetailList.forEach(pc=>{
            //     if(prod.IntegralCode==pc.IntegralCode){
            //       isproduct=true;
            //     }
            //   });
            // });
            that.base.IntegralCodeDetailList.forEach(pc => {
              if (pc == obj.Code) {
                isproduct = true;
              }
            });
            if (isproduct) {
              that.msg.Alert("已录入，请勿重复录入");
              return;
            } else {
              that.base.IntegralCodeDetailList.push(obj.Code);
            }
          } else {
            that.base.IntegralCodeDetailList.push(obj.Code);
          }
          let _data = {};
          _data["id"] = data.Status.productId;
          _data["name"] = data.Status.productname;
          _data["num"] = data.Status.Count;
          // _data["Code"]=obj.Code;
          _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
          let isproductnum: boolean = false;
          that.base.GridArrayData.forEach(item => {
            if (item.id == data.Status.productId) {
              data.Status.IntegralCodeDetailList.forEach(items => {
                item.IntegralCodeDetailList.push(items);
              });
              let coun1: number = item.num;
              let count2: number = data.Status.Count;
              let count3: number = coun1 + count2;
              item.num = count3;
              isproductnum = true;
            }
          });
          if (!isproductnum) {
            that.base.GridArrayData.push(_data);
          }
          let sumNum: number = data.Status.Count;
          that.base.GridListCount += sumNum;
        } 
        else
         {
          if (data.Status.Datas.length > 0) {
            if (data.Status.Datas.length > 0) {
              console.log(data.Status);
              data.Status.Datas.forEach(it => {
                let TankBarcodelen = it.TankBarcode.split(",").length;
                let BoxCountlen = data.Status.BoxCount;
                if (TankBarcodelen > BoxCountlen && TankBarcodelen > 1) {
                  that.BoxCountlenall = data.Status.BoxCount;
                } else if (TankBarcodelen <= BoxCountlen && TankBarcodelen > 1) {
                  that.BoxCountlenall = TankBarcodelen;
                }
                else {
                  that.BoxCountlenall = 1;
                }

              })

              console.log(data.Status.Datas);
              // console.log(data.Status.TankBarcode);
              //   console.log(data.Status.TankBarcode.split(","));
              //   console.log(data.Status.TankBarcode.split(",").length);
              // that.baseService.ListData.forEach(it=>{
              //   console.log(it.TankBarcode);
              //   console.log(it.TankBarcode.split(","));
              //   console.log(it.TankBarcode.split(",").length);

              // })
              let isExists = false;
              // data.Status.Datas.forEach(it => {//判断箱码
              //   if(that.baseService.arrayData.find(x=>x.BoxBarcode==it["BoxBarcode"]))
              //   {
              //    isExists=true;
              //    return false;
              //   }
              // });

              // if(!isExists){

              data.Status.Datas.forEach(_t => {//判断罐码
                let _newTp: Array<any> = _t.TankBarcode.split(",") || [];//返回结果
                _newTp.forEach(_m => {
                  that.baseService.arrayData.forEach(s => {
                    let _tp: Array<any> = s.TankBarcode.split(",") || [];
                    if (_tp == _m) {
                      isExists = true;
                    }
                  });
                });

              });
              // }
              if (isExists) {
                that.msg.Alert("已录入，请勿重复录入");
                return false;
              }

              data.Status.Datas.forEach(it => {
                console.log(it, "+++++++++++++++++++++++++++++")
                // that.baseService.arrayData =[];
                let pushObj = {};
                pushObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
                pushObj["TankBarcode"] = it["TankBarcode"] || "";
                pushObj["BoxBarcode"] = it["BoxBarcode"] || "";
                pushObj["PurchaseID"] = it["PurchaseID"] || "";
                pushObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
                pushObj["BoxCount"] = that.BoxCountlenall || "";

                that.baseService.arrayData.push(pushObj);//完全的添加数据
                // that.baseService.ListData.push(pushObj);

                //修饰过得数据
                if (that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])) {
                  data.Status.Datas.forEach(it => {
                    let TankBarcodelen = it.TankBarcode.split(",").length;
                    let BoxCountlen = data.Status.BoxCount;

                    if (TankBarcodelen > BoxCountlen && TankBarcodelen > 1) {
                      console.log("显示的数据")
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + BoxCountlen;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = BoxCountlen;


                    } else if (TankBarcodelen <= BoxCountlen && TankBarcodelen > 1) {
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + TankBarcodelen;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = TankBarcodelen;
                    }
                    else {
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["Num"] + 1;
                      that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = that.baseService.ListData.find(x => x.ProductInfoCode == it["ProductInfoCode"])["BoxCount"] = 1;
                    }


                    console.log("里边罐码的数量", it.TankBarcode.split(",").length);

                  })
                } else {
                  //  
                  let newListObj = {};
                  newListObj["ProductInfoCode"] = it["ProductInfoCode"] || "";
                  newListObj["TankBarcode"] = it["TankBarcode"] || "";
                  newListObj["PurchaseID"] = it["PurchaseID"] || "";
                  newListObj["ProductName"] = it["ShortName"] || it["ProductName"] || "";
                  newListObj["Num"] = it["Num"] || "";
                  newListObj["BoxCount"] = it["BoxCount"] || "";



                  // 箱规的数量
                  console.log("箱规", data.Status.BoxCount);
                  data.Status.Datas.forEach(it => {
                    let TankBarcodelen = it.TankBarcode.split(",").length;

                    if (TankBarcodelen > data.Status.BoxCount && TankBarcodelen > 1) {
                      console.log("显示的数据zzzzzzzzzzzzzzzz")
                      newListObj["Num"] = data.Status.BoxCount;
                      newListObj["BoxCount"] = data.Status.BoxCount;
                    } else if (TankBarcodelen <= data.Status.BoxCount && TankBarcodelen > 1) {
                      console.log("显示的数据z,mmmmmmm")
                      newListObj["Num"] = TankBarcodelen;
                      newListObj["BoxCount"] = TankBarcodelen;
                    } else {
                      newListObj["Num"] = 1;
                    }

                    // if(data.Status.BoxCount !== TankBarcodelen &&  TankBarcodelen >1 && data.Status.BoxCount > TankBarcodelen){
                    //   console.log("显示的数据")
                    //   newListObj["Num"]=data.Status.BoxCount;
                    //   newListObj["BoxCount"]=data.Status.BoxCount;
                    // }else if(TankBarcodelen < data.Status.BoxCount   &&  TankBarcodelen >1){
                    //   newListObj["Num"]=TankBarcodelen;
                    //   newListObj["BoxCount"]=TankBarcodelen;
                    // }
                    // else{
                    //   newListObj["Num"]=1;
                    // }

                    console.log("里边罐码的数量", it.TankBarcode.split(",").length);
                  })
                  console.log('tag', newListObj);
                  that.baseService.ListData.push(newListObj);
                  //  that.baseService.arrayData.push(newListObj);

                }

                // that.baseService.ListData=that.baseService.arrayData ;
                console.log("listdata", that.baseService.ListData)
                console.log("yuanshi", that.baseService.arrayData)
              });
            }
            //    let code=obj["Code"];
            //    that.baseService.arrayData.forEach(item=>{
            //  if(that.baseService.ListData.find(x=>x.ProductInfoCode==code))
            //  {
            //   that.baseService.ListData.find(x=>x.ProductInfoCode==code)["Num"]=that.baseService.ListData.find(x=>x.ProductInfoCode==code)["Num"]+1;
            //  }else{
            //   //  

            //   let newListObj={};
            //   newListObj["ProductInfoCode"]=item["ProductInfoCode"]||"";
            //   newListObj["PurchaseID"]     =item["PurchaseID"]||"";
            //   newListObj["ProductName"]    =item["ProductName"]||"";
            //   newListObj["Num"]    =1;
            //   that.baseService.ListData.push(newListObj);

            //  }

            //  

          }
        }
      }
      else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    })
  }
}
